import script from "./ModalCreateChat.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCreateChat.vue?vue&type=script&setup=true&lang=js"

import "./ModalCreateChat.vue?vue&type=style&index=0&id=c5ec7322&lang=scss"

const __exports__ = script;

export default __exports__